import React, {  useState, useMemo, useEffect } from 'react';
import Select from 'react-select';
import { useProfileState } from 'context/profile'
import { reactSelectStyles } from 'components/Shared/ReactSelectStyles'

export function useGroupList() {
    const { status, profile } = useProfileState();
    
    const groupsMap = useMemo(() => {
        return new Map(
            profile?.tenantGroups?.map?.(d => 
                ( [ d._id, {label: d.name, value: d._id, ...d } ] )
            )
        )
    }, [profile.tenantGroups])


    return { isLoading: status === 'loading', isFetching: status === 'fetching', groupsMap, groupsArray: Array.from(groupsMap.values())  }
}

export function TenantGroupsSelect({ isDisabled, value, onChange, ...props }) {
    const [realValue, setRealValue] = useState(null);
    const { groupsArray, groupsMap, isLoading, isFetching } = useGroupList();

    useEffect(() => {
        if (groupsMap.get(value)) {
            setRealValue(groupsMap.get(value))
        } else {
            setRealValue(null)
        }
    }, [groupsMap, value])

    const handleChange = (option) => {
        onChange(option?.value || null, option)
    }

    return <Select 
        options={groupsArray}
        isLoading={isLoading || isFetching}
        isDisabled={isLoading || isDisabled}
        styles={reactSelectStyles}
        value={realValue}
        onChange={handleChange}
        {...props}
    />
}